<template>
  <div>
    <b-card>
      <b-row class="mb-3">
        <b-col sm="12">
          <ul>
            <li v-for="(file, key) in computedFiles" :key="key" v-text="file" />
          </ul>
          <div v-show="computedFiles.length == 0">
            No Pending Files
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ['files'],
  computed: {
    computedFiles() {
      if (!Array.isArray(this.files)) {
        return []
      }
      return this.files
    },
  },
}
</script>

<style>

</style>
